var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "", "mt--50": "" } },
    [
      _c("core-refresh-informer", {
        attrs: { time: _vm.refreshTime },
        on: { refresh: _vm.refreshData },
      }),
      _c("core-filter"),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm5: "", md4: "", lg3: "", xl2: "" } },
            [
              _c("v-select", {
                attrs: {
                  label: _vm.$t("Common.programmer"),
                  items: _vm.workers,
                  "item-value": "idx",
                  "item-text": "name",
                  clearable: "",
                },
                on: {
                  "click:clear": function ($event) {
                    _vm.selectedWorker = undefined
                  },
                },
                model: {
                  value: _vm.selectedWorker,
                  callback: function ($$v) {
                    _vm.selectedWorker = $$v
                  },
                  expression: "selectedWorker",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "mobile-margin mt--20" },
        [
          _c(
            "v-card-title",
            { staticClass: "pt-0 pb-1" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "context-search",
                        attrs: {
                          label: _vm.$t("Common.search"),
                          "prepend-inner-icon": "mdi-magnify",
                          clearable: "",
                          "single-line": "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-layout",
                { attrs: { column: "", "align-end": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "" } },
                    [
                      _vm.isAdditionTaskAllowed
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                color: "green darken-1",
                                elevation: "2",
                                small: _vm.screenWidth <= _vm.mobileMaxWidth,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addTask(null)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Common.add")) + " ")]
                          )
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "grey darken-1",
                            elevation: "2",
                            small: _vm.screenWidth <= _vm.mobileMaxWidth,
                          },
                          on: { click: _vm.showBacklog },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("Common.unassigned")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _vm._l(_vm.filteredData, function (item) {
            return [
              item.tasks.length > 0
                ? _c(
                    "v-flex",
                    {
                      key: item.workerName,
                      staticClass: "pb-0",
                      attrs: { xs12: "" },
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "mobile-margin" },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", "text-xs-center": "" } },
                                [
                                  _c("h3", [_vm._v(_vm._s(item.workerName))]),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Common.totalTime")) +
                                        " " +
                                        _vm._s(item.totalTime) +
                                        " " +
                                        _vm._s(_vm.$t("Common.hours"))
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("v-data-table", {
                            staticClass: "elevation-1 text-xs-center",
                            attrs: {
                              headers: _vm.workerTableHeaders,
                              items: item.tasks,
                              "hide-actions": "",
                              "disable-initial-sort": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "headers",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "tr",
                                        [
                                          _vm._l(
                                            props.headers,
                                            function (header, headerIndex) {
                                              return [
                                                typeof header.value === "string"
                                                  ? _c(
                                                      "th",
                                                      {
                                                        key: headerIndex,
                                                        class:
                                                          "column text-xs-center " +
                                                          header.class,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              header.text
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "items",
                                  fn: function (rows) {
                                    return [
                                      _c(
                                        "tr",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.onRowClick(rows.item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              class: _vm.statusColor(rows.item),
                                              attrs: { width: "10%" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      rows.item["ДатаНачала"]
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { attrs: { width: "80%" } },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    rows.item["Описание"]
                                                  ) +
                                                  " ("
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-medium font-italic",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(rows.item["Автор"])
                                                  ),
                                                ]
                                              ),
                                              _vm._v(") "),
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { attrs: { width: "10%" } },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    rows.item["ВремяПлан"]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "no-data",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-center" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.noDataMsg) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "no-results",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.noDataMsg)),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm.modalOpen
        ? _c("okil-add-task-window", {
            staticClass: "mobile-margin",
            attrs: {
              open: _vm.modalOpen,
              workers: _vm.workers,
              backlog: _vm.backlog,
              variant: _vm.variant,
              comment: _vm.comment,
              "screen-width": _vm.screenWidth,
              "screen-height": _vm.screenHeight,
              "mobile-max-width": _vm.mobileMaxWidth,
            },
            on: { "add-task": _vm.addTask, "assign-task": _vm.assignTask },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }